module.exports = __webpack_public_path__ + "img/drone.65098b4c.svg";